module.exports = __webpack_public_path__ + "img/item1.ef44cb46.png";